<template>
  <div class="footer has-background-white">
    <div class="container">
      <div class="level">
	<div class="level-left">
	  <div class="level-item">
	   <a href="https://readcoop.eu/readsearch/" target="_blank">
	      <figure>
		<img class="footer-logo" alt="Read Coop" src="@/assets/logo-footer-1.svg">
	      </figure>	      
	    </a>
	  </div>
	  <div class="level-item">
	   <a href="https://www.oesta.gv.at/" target="_blank">
	      <figure>
		<img class="footer-logo" alt="Read Coop" src="@/assets/logo-footer-2.png">
	      </figure>	      
	    </a>
	  </div>	  
	   <div class="level-item">
	   <a href="https://www.uibk.ac.at/zeitgeschichte/index.html.de" target="_blank">
	      <figure>
		<img class="footer-logo" alt="Read Coop" src="@/assets/logo-footer-3.jpg">
	      </figure>	      
	    </a>
	  </div>	  
	</div>
	<div class="level-right" style="margin-bottom: auto">
	  <div class="level-item">
	    <div class="content">
	      <div>
		<router-link
		  :to="{ name: 'Imprint' }"
		  class="is-family-secondary has-text-weight-bold"
		>
		  {{$t('Imprint')}}
		</router-link>
	      </div>
	      <p>
		<router-link
		  :to="{ name: 'Privacy' }"
		  class="is-family-secondary has-text-weight-bold"
		>
		  {{$t('Privacy')}}
		</router-link>		
	      </p>
	    </div>
	  </div>
	</div>
      </div>
    </div>
  </div>
</template>

<style>
 .footer-logo {
   height: 3rem;
 }

.footer {
	padding: 1.5rem 1.5rem 1.5rem !important;
}

 .footer-divider {
   margin: 0 1rem;
   width: 0.075rem;
   height: 4rem;
   background-color: white;
 }
</style>

<script>
 export default {
   computed: {
     version() {
       return require('@/../package.json').version
     }
   }
 }
</script>
